import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { Logo } from "@/components/brand/Logo";

// Platform admin (app.virtualdesk.ai) is out of scope for the MVP — this
// full-screen placeholder ships in its place.
export function PlatformShell() {
  return (
    <div className="min-h-screen bg-brand-midnight text-brand-ink flex flex-col">
      <header className="border-b border-border/60 px-6 py-4">
        <Logo />
      </header>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md text-center space-y-6">
          <div className="mx-auto w-12 h-12 rounded-full bg-brand-violet/15 flex items-center justify-center text-brand-violet">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <h1 className="font-display text-4xl">Platform admin — coming soon</h1>
          <p className="text-sm text-muted-foreground">
            This workspace is reserved for VirtualDesk staff. If you're looking for your tenant
            dashboard, head to <span className="font-mono">&lt;your-code&gt;.virtualdesk.ai</span>.
          </p>
          <Button asChild variant="primary">
            <a href="https://virtualdesk.ai">Back to virtualdesk.ai</a>
          </Button>
        </div>
      </main>
    </div>
  );
}
